import { Box, Typography } from "@mui/material"
import { QrScanner } from "../QrScanner/QrScanner"
import { StyledCratemenu } from "./CrateMenu.styled"
import { useContext, useEffect, useState } from "react"
import { LanguageContext } from "../../globals/LanguageContext"
import { Crate } from "../../models/Crate"
import { useCrate } from "../../stores/useCrate"
import { useProfile } from "../../stores/useProfile"
import { MaterialItem } from "../materialItem/MaterialItem"
import { useCrateType } from "../../hooks/useCrateType"
import { CrateList } from "../crateList/CrateList"
import { MaterialTable } from "../materialTable/MaterialTable"

export const CrateMenu = () => {
    const {dictionary} = useContext(LanguageContext);
    const [selectedCrate, setSelectedCrate] = useState<Crate | null>(null);
    const [shouldUpdate, setShouldUpdate] = useState<boolean>(true);
    const [code, setCode] = useState<string>("");
    const {fetchCrateByCode} = useCrate();
    const {user} = useProfile();
    const {filteredCrates} = useCrateType(selectedCrate?.type);

    const handleScan = async () => {
        if (!user || !code) return;
        const crate = await fetchCrateByCode(user, code.split("-")[1]);
        if (crate) setSelectedCrate(crate);
    }

    useEffect(() => {
        handleScan();
    }, [code])

    return <StyledCratemenu>
        <QrScanner setCode={(code) => setCode(code)}/>
            <Box className="crateInfo"><Typography variant="h2">{dictionary.pages.materials.crates.crate} {selectedCrate?.type || "XX"}-{selectedCrate?.code || "XXXX"}</Typography>
            <Typography variant="h2">{dictionary.pages.materials.crates.type} {filteredCrates && filteredCrates[0].text}</Typography>
            <Box className="tableWrapper">{selectedCrate && <MaterialTable filteredMaterials={selectedCrate?.materials} onSave={handleScan} crateId={selectedCrate.id}></MaterialTable>}</Box>
            </Box>
    </StyledCratemenu>
}